/* unplugin-vue-components disabled */import script from "./video.vue?vue&type=script&lang=jsx"
export * from "./video.vue?vue&type=script&lang=jsx"

import "./video.vue?vue&type=style&index=0&id=4c240d39&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c240d39"]])

export default __exports__